import { apiSlice } from '../../api/apiSlice';
import {
    UsersListAPIResponse,
    UsersListQueryParams,
} from './roleUsersApiSliceTypes';

const roleUsersApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getRoleUsers: builder.query<UsersListAPIResponse, UsersListQueryParams>(
            {
                query: (params) => {
                    const {
                        page = 1,
                        limit = 10,
                        acceptLanguage = 'en',
                        ...queryParams
                    } = params;

                    return {
                        url: `/roles/${queryParams.roleId}/users`,
                        method: 'GET',
                        headers: {
                            'Accept-Language': acceptLanguage,
                        },
                        params: {
                            page,
                            limit,
                            sortBy: queryParams.sortBy ?? 'createdAt',
                            sortOrder: queryParams.sortOrder ?? 'DESC',
                            search: queryParams.search,
                        },
                    };
                },
            }
        ),
    }),
    overrideExisting: true,
});

export const { useGetRoleUsersQuery, useLazyGetRoleUsersQuery } =
    roleUsersApiSlice;
